export default __webpack_public_path__ + "static/media/screen1.a96a3cef.png";